import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonService } from '@services/common.service';
import { Language } from '@shared/models/language';
import { User } from '@shared/models/user';
import { ActivatedRoute, Router, Routes, RoutesRecognized } from "@angular/router";

import { filter, pairwise } from 'rxjs/operators';
import { LocaleService } from '@core/services/locale.service';
import { BaseModuleComponent } from '@modules/base-module/base-module.component';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { InboxService } from '@core/services/inbox.service';
import { UserRole } from '@shared/models/codebooks/user-role';
import { DataService } from '@core/services/data.service';
import { HttpClient } from '@angular/common/http';
import { UserProfileDropdownComponent } from 'az-customer-portal-ui';

/*
@Injectable({
  providedIn: 'root'
})
*/
@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TopbarComponent extends BaseModuleComponent implements OnInit, AfterViewInit {

    @ViewChild('userProfileDropdown') userProfileDropdown: UserProfileDropdownComponent;

    public loggedUser: User = new User();
    public activeLanguage: Language;
    public languages: Language[];
    public logoutUrl: string;
    public isDrawerOpen = false;

    public notOpenedMails = 0;

    public topBarName = '';

    constructor(
        public commonService: CommonService,
        public dataService: DataService,
        private localeService: LocaleService,
        private router: Router,
        private inboxService: InboxService,
        private http: HttpClient,
        private cookieService: CookieService
    ) {

        super(commonService);
        this.loggedUser = this.getLoggedUser();

        this.topBarName = this.loggedUser.firstName + ' ' + this.loggedUser.lastName;
        if (this.loggedUser.role !== UserRole.Individual) {
            this.topBarName = this.loggedUser.vatNumber;
        }

        this.languages = this.localeService.languages;
        this.localeService.activeLanguage.subscribe(() =>
            this.activeLanguage = this.languages.find(x => x.code.toLowerCase() === this.loggedUser.locale)
        );
        this.logoutUrl = commonService.logoutUrl;
        
    }

    ngAfterViewInit(): void {
        //
    }

    ngOnInit(): void {
        this.loadInboxList();
        
        this.router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized))
            .subscribe((event: RoutesRecognized) => {
                this.extendSsoSession();
                event.url != '/inbox' ? this.loadInboxList() : this.dataService.notOpenedEmails.subscribe(count => {
                    this.notOpenedMails = count;
                });

                this.userProfileDropdown.isDrawerOpen = false;
                this.isDrawerOpen = false;
                this.commonService.hideAlertAgentSource();
            });
    }

    getMenuItems(): Routes {
        return this.router.config.filter(r => {
            return r.data.enabled && r.data.roles && r.data.roles.includes(this.loggedUser.role) && r.path != 'moj-profil';
        });
    }

    changeLanguage(language: Language): void {
        this.localeService.changeLanguage(language.code);
    }

    getAccessManagementUrl(): string {
        return this.loggedUser.profileUrl + '/' + this.commonService.accessManagementUrl;
    }

    handleOpen(): void {
        this.isDrawerOpen = !this.isDrawerOpen;
    }

    logoClicked(e): void {
        this.router.navigate(['']);
    }

    // first load app
    private loadInboxList(): void {
        if (this.loggedUser.role != 1) {
            return;
        }

        this.inboxService.getInboxList('inbox').subscribe(mailList => {
            this.notOpenedMails = mailList.unreadMessagesCount;
            this.dataService.notOpenedEmails.next(this.notOpenedMails)
            this.dataService.notOpenedEmails.subscribe(count => {
                this.notOpenedMails = count;
            });
        });
    }

    private extendSsoSession() {
        fetch(this.loggedUser.profileUrl + '/prihlasenie/session.gif', {
            mode: 'no-cors',
            credentials: 'include'
        })
    }
}
